import CustomerSupportIcon from '@/assets/icons/customer-support-icon.svg';
import ZECustomerService from '@/components/customerService';
import { CustomerFieldsEnum } from '@/constants/customerService';
import { EXPCONFIG_FAST } from '@/constants/point';
import { useTranslation } from '@/i18n/client';
import { EXPOSURE_RECORD, sendClickTrack } from '@/tracks/25630';
import cn from 'clsx';
import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect, useRef, useState } from 'react';
import { Props } from '../index';
import floatingToolBtnStyle from './FloatingToolBarBtn.module.scss';
import JDILogin from '@/app/login/index.login';

const JDICustomerSupport = ({ onOpen }: Props) => {
  const zeRef = useRef<any>(null);
  const [serviceFields, setServiceFields] = useState<any>([]);
  const { t } = useTranslation();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (pathname.includes('/profile/my-orders/order-details')) {
      // 在订单详情页面打开客服对话框需要传订单id
      const orderId = searchParams.get('orderId');
      setServiceFields([{ id: CustomerFieldsEnum.ORDER_NO, value: orderId }]);
    } else if (pathname.includes('/dp')) {
      const href = (window as any).location.href;
      // 在商详页面传商详链接过去
      setServiceFields([{ id: CustomerFieldsEnum.PRODUCT_URL, value: href }]);
    } else {
      setServiceFields([]);
    }
  }, [pathname]);

  const handleCustomerSupport = async () => {
    try {
      const userInfo = await JDILogin.getInstance().getUserInfo();
      if (userInfo.isLoggedIn) {
        onOpen && onOpen();
        if (zeRef.current) {
          zeRef.current.openService();
        }
      } else {
        sessionStorage.setItem('OpenCustomerFromLogin', 'true');
        JDILogin.getInstance().jumpToLoginPage();
      }
      sendClickTrack.Sidebar_Customer_Click();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div
      exptag={'exp|' + EXPOSURE_RECORD.Sidebar_Customer_Expo}
      data-exptag-config={EXPCONFIG_FAST}
    >
      <button
        className={cn(floatingToolBtnStyle.floatingBtn, floatingToolBtnStyle.heightLarger)}
        onClick={handleCustomerSupport}
      >
        <div className={floatingToolBtnStyle.iconTextWrap}>
          <CustomerSupportIcon className={floatingToolBtnStyle.hoverIcon} />
        </div>
        <div className={floatingToolBtnStyle.btnText}>
          {t('floatingToolbar.customerService', { interpolation: { escapeValue: false } })}
        </div>
      </button>
      {/* 客服组件引入 */}
      <ZECustomerService ref={zeRef} serviceFields={serviceFields} />
    </div>
  );
};

export default JDICustomerSupport;
